import { API } from "aws-amplify";


// get Quick Prints data
export const getQuickPrintsData=async(facilityId = null)=>{

    try{
        const queryStringParameters = facilityId ? { facilityId } : {};
        const response =  await API.get('quick-prints', '/quick-prints-data', {
              response: true,
              queryStringParameters,
            });
            return response.data;
    }catch(error){
        console.error("Error getting Quick Prints data:", error);
        return null;
    }
};

// create Quick Prints data
export const createQuickPrintsData=async(requestbody, facilityId = null)=>{

    try {
        const response = await API.post('quick-prints', '/quick-prints-data', {
            body: { ...requestbody, FacilityId: facilityId },
        });
        return response;
    } catch (error) {
        console.error("Error creating Quick Prints data:", error);
        throw error;
    }

};


//  update quick prints Data
export const updateQuickPrintsData=async(requestbody, facilityId = null)=>{
        try{
            const response = await API.put('quick-prints', '/quick-prints-data', {
                body: { ...requestbody, FacilityId: facilityId },
            });
            return response;
        }catch(error){
            console.error("Error in updating Quick Prints data:", error);
            return null;
        }
}



export const uploadImageToS3=async(signedUrl,file,contentType)=>{
    console.log("Uploading to S3 with signed URL:", signedUrl);
    console.log("File to upload:", file);
    console.log("Content Type:", contentType);
    try {
        const response = await fetch(signedUrl, {
            method: 'PUT',
            headers: {
                'Content-Type': contentType // Ensure this matches the Content-Type in the signed URL
            },
            body: file // Directly use the File object from the input
        });
  
        if (response.ok) {
            console.log('Upload successful');
            return true;
        } else {
            console.error('Upload failed');
            return false;
        }
    } catch (error) {
        console.error('Error uploading the file:', error);
        return  false;
    }
  }